module.exports = __webpack_public_path__ + "static/Fotografias_caracteristicas_3-66cee854228e3fcb040e553361ecf640.jpg";